import type { AgentRuntimeToolCallItem } from "@cord/shared"

function normalizeToolName(toolName: string | null | undefined): string {
  return toolName?.trim().toLowerCase().replace(/^mcp__cord__/, "") ?? ""
}

export function resolveToolDisplayOutput(args: {
  toolName: string | null | undefined
  status: AgentRuntimeToolCallItem["status"]
  output: unknown
  metadata: Record<string, unknown> | undefined
}): unknown {
  if (args.output != null) {
    return args.output
  }

  const normalizedToolName = normalizeToolName(args.toolName)
  if (
    (args.status === "pending" || args.status === "running")
    && (normalizedToolName === "bash" || normalizedToolName === "shell")
  ) {
    return args.metadata?.output
  }

  return args.output
}

export function stringifyToolDisplayOutput(args: {
  toolName: string | null | undefined
  status: AgentRuntimeToolCallItem["status"]
  output: unknown
  metadata: Record<string, unknown> | undefined
}): string {
  const value = resolveToolDisplayOutput(args)
  if (typeof value === "string") return value
  if (value == null) return ""
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value)
  }
}
